import { createFileRoute } from "@tanstack/react-router";
import DealerVsPrivatGuide from "@/pages/ghiduri/DealerVsPrivatGuide";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/ghiduri/dealer-verificat-vs-vanzator-privat/")({
  head: () => routeHead("/ghiduri/dealer-verificat-vs-vanzator-privat/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DealerVsPrivatGuide />
  );
}
